export default __webpack_public_path__ + "static/media/informationIcon.f4eada33.svg";